"use client";

import { useTranslations } from "@/i18n/client";
import { Link } from "@/i18n/Link";
import { memo, type ComponentProps } from "react";
import styles from "./Breadcrumb.module.css";

export const BreadcrumbRoot = memo(({ children, className, ...rest }: ComponentProps<"ol">) => {
	const t = useTranslations();
	return (
		<nav className={className} aria-label={t("Breadcrumb")}>
			<ol className={styles.root} {...rest}>
				{children}
			</ol>
		</nav>
	);
});

BreadcrumbRoot.displayName = "BreadcrumbRoot";

export const BreadcrumbItem = memo(
	({ children, href, ...rest }: ComponentProps<"li"> & { href?: string }) => {
		const inner = href ? (
			<Link href={href} className="">
				{children}
			</Link>
		) : (
			children
		);

		return (
			<li className={styles.item} {...rest}>
				{inner}
			</li>
		);
	},
);

BreadcrumbItem.displayName = "BreadcrumbItem";

export const BreadcrumbSeparator = () => (
	<span aria-hidden className={styles.separator}>
		/
	</span>
);

export { BreadcrumbItem as Item, BreadcrumbRoot as Root, BreadcrumbSeparator as Separator };
